import React, { Fragment } from "react"
import Header from "./header";
function OuterFrame({ children }) {
    return (<Fragment>
        <Header />
        <div style={{ height:"calc(100% - 70px)",padding: "0",margin:"0",overflowY:"auto" }}>
            {children}
        </div>
       
    </Fragment>)
}
export default OuterFrame;